export default __webpack_public_path__ + "8aa5737f767a49269c94d1e0b23091b7.png";